// export interface IAndroid {
//     onCallJsEvent(type:string, value:string):void
// }
export * from './android/'
// export * from './data'
export * from './types'
export * from './htmls'
export * from './mc/AndroidController'
export * from './confs'